import { render, staticRenderFns } from "./DeleteContractorModal.vue?vue&type=template&id=60e327ce"
import script from "./DeleteContractorModal.vue?vue&type=script&lang=js"
export * from "./DeleteContractorModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteContractorModal.vue?vue&type=style&index=0&id=60e327ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports